// import { Link } from "react-router-dom";

function SkiLifts() {
  return (
    <>
      <main>
        <h2>Welcome to the ski lifts!</h2>
        <p>You can do this, I believe in you.</p>
      </main>
      <nav>
        {/* <Link to="/about">About</Link> */}
      </nav>
    </>
  );
}

export default SkiLifts;